const cache = {};

export function getCache(key) {
  const entry = cache[key];
  if (!entry) return null;

  if (entry.expires < Date.now()) {
    delete cache[key];
    return null;
  }

  return entry.data;
}

export function setCache(key, data, ttlMs = 5 * 60 * 1000) {
  cache[key] = {
    data,
    expires: Date.now() + ttlMs,
  };
}
export async function fetchOnce(key, ttl, fetchFunc) {
  const cached = getCache(key);
  if (cached) return cached; // immediate return

  const data = await fetchFunc();
  setCache(key, data, ttl);

  return data;
}
